import React, { useEffect, useState } from "react";
import { Box, Typography } from "@mui/material";
import moment from "moment";
import { useDispatch, useSelector } from "react-redux";
import SearchIcon from "@mui/icons-material/Search";
import ClearIcon from "@mui/icons-material/Clear";
import { useHistory } from "react-router-dom";
import {
  AntSwitchComponent,
  Breadcrumb,
  ButtonComponent,
  TableComponent,
} from "../../component";
import { SubadminList, updatePermission } from "../../store/actions";
import FormInput from "../../component/common/outlined-input";
import EditIcon from "@mui/icons-material/Edit";
import Visibility from "@mui/icons-material/Visibility";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from "@mui/material";
import { checkContainsTargetString } from "../../helper/utils";
import { getCookies } from "../../helper/constant";

const RolemanagementList = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const [page, setPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [tableData, setTableData] = useState([]);
  const [order, setOrder] = useState(-1);
  const [orderBy, setOrderBy] = useState("start");
  const [modalswitchcontent, setmodalswitchcontent] = useState([0, 0]);
  const [modalSwitch, setModalSwitch] = useState(false);
  const [getApiCall, setGetApiCall] = useState(false);
  //   const { getHistoryData, getHistoryLoader } = useSelector(
  //     (state) => state.subscriptionPlanReducer
  //   );
  // const permission = useSelector((state) => state.loginReducer.permissions);
  const [total, setTotal] = useState(0);
  const [search, setSearch] = useState("");
  const [formData, setFormData] = useState({
    search: "",
  });

  const handleBack = () => {
    history.push({
      pathname: `/role-management/add/show`,
      state: {
        access: "Add",
      },
    });
  };

  const handleStatusChange = (e, itm) => {
    setmodalswitchcontent([e, itm]);
    setModalSwitch(true);
  };

  const loginData = getCookies("permissiontt");

  const permissionsArray = loginData
    .split(",")
    .filter((value) => value.trim() !== "");

  // const targetString = 'role-management/edit';

  // const containsEnvironment = checkContainsTargetString(permissionsArray, targetString);

  const tableHeaders = [
    {
      id: "index",
      numeric: false,
      disablePadding: false,
      label: "#",
    },
    {
      id: "username",
      numeric: false,
      disablePadding: false,
      label: "Username",
    },
    {
      id: "email",
      numeric: false,
      disablePadding: true,
      label: "Email",
    },
    // {
    //   id: "createdby",
    //   numeric: false,
    //   disablePadding: true,
    //   label: "Created By(Role)",
    // },
    {
      id: "createdon",
      numeric: false,
      disablePadding: true,
      label: "Created On",
    },
    {
      id: "last_login",
      numeric: false,
      disablePadding: true,
      label: "Last login",
    },
    // {
    //   id: "status",
    //   numeric: false,
    //   disablePadding: false,
    //   label: "Status",
    // },
    {
      id: "action",
      numeric: false,
      disablePadding: false,
      label: "Actions",
    },
  ];

  useEffect(() => {
    dispatch(
      SubadminList({
        payload: {
          limit: rowsPerPage,
          page: page,
          search: search,
          orderBy: orderBy,
          order: order,
        },
        callback: (getData) => {
          console.log(getData, "getData+++++++++++++++++++++++++++")
          const d = getData?.data?.map((itm, index) => ({
            index: index + 1,
            id: itm?._id,
            username: itm?.userName,
            email: itm?.emailAddress || "-",
            createdby: "-",
            createdon: moment(itm?.createdAt).format("DD-MM-YYYY LT") || "-",
            last_login: moment(itm?.lastLoginAt).format("DD-MM-YYYY LT") || "-",
            action: {
              actionEdit: (
                  <EditIcon color={"action"} />
                
              ),

              actionView: <Visibility color={"action"} />,
            },
          }));
          setTableData(d);
          setTotal(getData?.totalRecords);
        },
      })
    );
  }, [page, rowsPerPage, search, getApiCall]);

  

  const handleEditRolemanagement = (data) => {
    const { id } = JSON.parse(JSON.stringify(data));
    history.push({
      pathname: `/role-management/edit/${id}`,
      state: {
        access: "Edit",
      },
    });
  };

  const handleViewRoleManagement = (data) => {
    const { id } = JSON.parse(JSON.stringify(data));
    history.push({
      pathname: `/role-management/view/${id}`,
      state: {
        access: "View",
      },
    });
  };

  const handleChangeSearch = (e) => {
    setFormData((prevState) => ({
      ...prevState,
      search: e?.target?.value,
    }));
    if (e?.key === "Enter") {
      setSearch(formData?.search);
    }
  };

  const handleClickSearch = () => {
    setSearch(formData?.search);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage + 1);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event?.target?.value));
    setPage(1);
  };

  const handleRemoveSearch = () => {
    setFormData((prevState) => ({
      ...prevState,
      search: "",
    }));
    setSearch("");
  };

  const handleSorting = (itm) => {
    setOrderBy(itm);
    setOrder(order === -1 ? 1 : -1);
  };

  // const handleStatusChangeAction = (e, itm) => {
  //   const form = {
  //     id: itm?._id,
  //     status: e?.target?.checked === true ? 1 : 0,
  //   };
  //   dispatch(
  //     updatePermission({
  //       form: form,
  //       callback: (d) => {
  //         setGetApiCall(!getApiCall);
  //       },

  //     })
  //   );
  // };

  return (
    <Box className={"mx-2"}>
      {/* <Dialog open={modalSwitch} onClose={() => handleStatusChange(false)}>
        <DialogTitle>Are you sure?</DialogTitle>
        <DialogContent>
          <DialogContentText>You want to change this status!</DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleStatusChangeAction} color="primary">
            Yes, Change Status
          </Button>
          <Button onClick={() => setModalSwitch(false)} color="secondary">
            Cancel
          </Button>
        </DialogActions>
      </Dialog> */}

      <Box className={"d-flex justify-content-between"}>
        <Box>
          <Typography variant="h5" className="poppins-font-family">
            Role Management
          </Typography>
          <Breadcrumb
            items={[{ page: "Home", path: "/dashboard" }]}
            active={{ page: "Role Management" }}
          />
        </Box>
        <Box>
          <FormInput
            placeholder={"Search"}
            name={"search"}
            value={formData?.search}
            onChange={(e) => handleChangeSearch(e)}
            handleKeyPress={handleChangeSearch}
            type="text"
            isRequired={false}
            style={{ marginTop: "10px", paddingBottom: "5px" }}
            endIcon={<SearchIcon />}
            clearIcon={formData?.search !== "" && <ClearIcon />}
            handleRemoveSearch={handleRemoveSearch}
            handleSearchClick={handleClickSearch}
          />

          <ButtonComponent
            variant="contained"
            buttonName="Add Subadmin"
            className={`common-btn`}
            handleClick={handleBack}
          />
        </Box>
      </Box>

      <TableComponent
        title={"List of Subadmin"}
        columns={tableHeaders}
        rows={tableData}
        page={page - 1}
        setPage={setPage}
        rowsPerPage={rowsPerPage}
        setRowsPerPage={setRowsPerPage}
        // loading={getHistoryLoader}
        total={total}
        isdisplay={tableData?.length > 0}
        // handleSorting={handleSorting}
        handleEditClick={handleEditRolemanagement}
        handleViewClick={handleViewRoleManagement}
        handleChangeRowsPerPage={handleChangeRowsPerPage}
        handleChangePage={handleChangePage}
      />
    </Box>
  );
};

export default RolemanagementList;
